import { APP_STATE } from './../States/app';

const defaultState = {
    industry: 'Hospitality',
    features: [],
    first: '',
    last: '',
    website: '',
    phone: '',
    email: ''
};

const reducer = function (state = defaultState, action) {
    //console.debug("reducer received: ", action, state);
    switch (action.type) {
        case APP_STATE.UpdateField:
            return {...state, ...action.fields}
        default:
            return state;
    }
};

export default reducer;
